export const da = window.navigator.language === 'da';